import { HeadLine } from '../../layouts/headers/HeadLine';
import { RoomSlideImage } from './components/RoomSlideImage';
import CSS from 'csstype';
import { useRequest } from '../../hooks/useRequest';
import { getApiUrl } from '../../app-config';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const RoomDetailPage = () => {

  const { roomid } = useParams();
  const { data } = useRequest(getApiUrl('Room/' + roomid));
  const [room, setRoom] = useState(null);

  useEffect(() => {
    if (data) setRoom(data);
  }, [data]);

  if (!room) {
    return (<div>Cargando habitación</div>)
  }

  return (
    <>
      <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
        <HeadLine title='Detalle de Habitación' backurl='../' />
      </div>

      <div className='w-full relative content-hi-sm detail-room'>

        <div className='flex flex-start'>
          <img src="/assets/img/icons/room2-icon.svg" alt="Mini icono" width="32px" height="32px" />
          <span className='title ml-2'>{room.name}</span>
        </div>

        <div className='mt-4'>
          <RoomSlideImage images={room.hotelRoomGalleries || []} />
        </div>

        <p style={{ fontSize: '14px' }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras pellentesque sollicitudin mattis. Maecenas porttitor pharetra efficitur. Etiam vehicula mauris id ex porttitor, at ullamcorper nisl ultrices.
        </p>

        <div className='mt-4' style={subtitlestyles}>
          Servicios
        </div>


        <div className='flex flex-col mt-4'>
          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>

          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>

          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>
          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>
          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>
          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>
          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>
          <div className='flex items-center correct-list'>  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00012 10.1998L2.50012 6.69982C2.11012 6.30982 1.49012 6.30982 1.10012 6.69982C0.710117 7.08982 0.710117 7.70982 1.10012 8.09982L5.29012 12.2898C5.68012 12.6798 6.31012 12.6798 6.70012 12.2898L17.3001 1.69982C17.6901 1.30982 17.6901 0.689824 17.3001 0.299824C16.9101 -0.0901758 16.2901 -0.0901758 15.9001 0.299824L6.00012 10.1998Z" fill="#67BAAF" />
          </svg>
            <span className='ml-2'>Lorem ipsum dolor sit amet.</span></div>
        </div>
      </div>
    </>
  );
};


const subtitlestyles: CSS.Properties = {
  fontSize: '18px',
  fontWeight: '600',
  color: '#012349',
  lineHeight: '18px'
}
